export default class CustomBadge {
	constructor() {
		this.instance = self;
	}

	static init() {
		const self = new CustomBadge();
		self.attachEvents();
		self.initBadgePrice();
	}

	attachEvents() {
		const self = this;

		// Toggle badge fields when checkbox is changed
		$(document).on('change', '.js-custom-badge-input', function() {
			const $this = $(this);
			const $badgeTabs = $('.badge-tabs');
			
			if ($this.is(':checked')) {
				$badgeTabs.removeClass('d-none');
			} else {
				$badgeTabs.addClass('d-none');
			}
			self.updateBadgePrice();
			self.updateFeeDisplay();
		});

		// Handle repeat badge checkbox
		$(document).on('change', '.js-badge-repeat-input', function() {
			self.updateFeeDisplay();
			self.updateBadgePrice();
		});

		// Handle artwork file upload
		$(document).on('change', '.js-badge-file-input', function() {
			const $this = $(this);
			const file = this.files && this.files[0];
			
			if (file) {
				const fileName = file.name;
				const fileExt = fileName.split('.').pop().toLowerCase();
				
				$('.js-badge-file-name').text(fileName).removeClass('d-none');
				$('.js-badge-file-remove').removeClass('d-none');
				$('.js-badge-file-label-text').text('File uploaded:');
				$('.badge-file-upload-area-thumbnail-icon').addClass('d-none');

				// Show appropriate icon based on file type
				if (fileExt === 'ai') {
					$('.illustrator-icon').removeClass('d-none');
					$('.eps-icon').addClass('d-none');
				} else if (fileExt === 'eps') {
					$('.eps-icon').removeClass('d-none');
					$('.illustrator-icon').addClass('d-none');
				} else {
					$('.illustrator-icon').addClass('d-none');
					$('.eps-icon').addClass('d-none');
				}

				// Show preview for image files
				if (['jpg', 'jpeg', 'png', 'gif', 'bmp'].includes(fileExt)) {
					const reader = new FileReader();
					reader.onload = function(e) {
						$('.badge-file-upload-preview').attr('src', e.target.result).removeClass('d-none');
					};
					reader.readAsDataURL(file);
				} else {
					$('.badge-file-upload-preview').addClass('d-none');
				}
			}
			self.updateFeeDisplay();
			self.updateBadgePrice();
		});

		// Handle file trigger click
		$(document).on('click keydown', '.js-badge-file-trigger', function(e) {
			if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
			e.preventDefault();
			$('.js-badge-file-input').trigger('click');
		});

		// Handle file remove
		$(document).on('click', '.js-badge-file-remove', function(e) {
			e.preventDefault();
			$('.js-badge-file-input').val('');
			$('.js-badge-file-label-text').text('Upload your file');
			$('.js-badge-file-name').addClass('d-none');
			$('.js-badge-file-remove').addClass('d-none');
			$('.badge-file-upload-preview').addClass('d-none');
			$('.illustrator-icon').addClass('d-none');
			$('.eps-icon').addClass('d-none');
			$('.badge-file-upload-area-thumbnail-icon').removeClass('d-none');
			self.updateFeeDisplay();
			self.updateBadgePrice();
		});
	}

	updateFeeDisplay() {
		const $badgeEnable = $('.js-custom-badge-input');
		const $setupFeeInfo = $('.js-badge-setup-fee-info');
		const $redrawFeeInfo = $('.js-badge-redraw-fee-info');
		
		$setupFeeInfo.addClass('d-none');
		$redrawFeeInfo.addClass('d-none');

		if (!$badgeEnable.is(':checked')) {
			return;
		}

		if ($('.js-badge-repeat-input').is(':checked')) {
			// No fees for repeat badges
			return;
		}

		const setupFeeAmount = parseFloat($badgeEnable.data('badge-setup-fee')) || 0;
		const redrawFeeStockcode = $badgeEnable.data('badge-redraw-stockcode') || '';

		// Show setup fee if configured
		if (setupFeeAmount > 0) {
			$('.js-setup-fee-amount').text(setupFeeAmount.toFixed(2));
			$('.js-setup-fee-stockcode').text(setupFeeAmount > 0 ? 'Setup Fee' : '-');
			$setupFeeInfo.removeClass('d-none');
		}

		// Check if artwork is uploaded and determine if redraw fee applies
		const $badgeArtwork = $('.js-badge-file-input');
		if ($badgeArtwork[0].files.length > 0) {
			const fileName = $badgeArtwork[0].files[0].name;
			const fileExt = fileName.split('.').pop().toLowerCase();
			const vectorFormats = ['ai', 'eps'];

			if (!vectorFormats.includes(fileExt) && redrawFeeStockcode) {
				const redrawFeeAmount = parseFloat($badgeEnable.data('badge-redraw-fee')) || 0;
				$('.js-redraw-fee-amount').text(redrawFeeAmount.toFixed(2));
				$redrawFeeInfo.removeClass('d-none');
			}
		}
	}

	updateBadgePrice() {
		const $badgeEnable = $('.js-custom-badge-input');
		let badgePrice = 0;

		if ($badgeEnable.length && $badgeEnable.is(':checked')) {
			const setupFeeAmount = parseFloat($badgeEnable.data('badge-setup-fee')) || 0;
			const redrawFeeStockcode = $badgeEnable.data('badge-redraw-stockcode') || '';
			
			if (!$('.js-badge-repeat-input').is(':checked')) {
				badgePrice += setupFeeAmount;
				
				// Check if redraw fee applies
				const $badgeArtwork = $('.js-badge-file-input');
				if ($badgeArtwork.length && $badgeArtwork[0].files.length > 0) {
					const fileName = $badgeArtwork[0].files[0].name;
					const fileExt = fileName.split('.').pop().toLowerCase();
					const vectorFormats = ['ai', 'eps'];
	
					if (!vectorFormats.includes(fileExt) && redrawFeeStockcode) {
						// Get redraw fee price from stockcode data attribute
						const redrawFeeAmount = parseFloat($badgeEnable.data('badge-redraw-fee')) || 0;
						badgePrice += redrawFeeAmount;
					}
				}
			}
		}

		// Update badge price display in totals
		const $badgeTotalElement = $('.js-product-team-quantity-total-badges');
		if ($badgeTotalElement.length) {
			$badgeTotalElement.text(badgePrice.toFixed(2));
		}

		// Notify Attributes that the badge price has been updated so it can recalculate totals
		$(document).trigger('badge:price-updated');
	}

	// Initialize badge price on page load
	initBadgePrice() {
		this.updateBadgePrice();
	}
}
